import React from 'react';
import { Filter, Main } from '../../../../containers/';
import { InputsText } from './inputs-text';
import { InputsDropdowns } from './inputs-dropdowns';
import 'PageStyles/styleguide/index.less';

const breadcrumbs = [{ title: 'Style Guide' }, { title: 'Forms' }];

export const Forms = props => (
  <div className="style-guide--page-buttons">
    <Filter title="Forms" breadcrumbs={breadcrumbs} />
    <Main>
      <InputsText />
      <InputsDropdowns />
    </Main>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/styleguide/components/Forms/index.js